import { Chat } from "./Chat";
import { Contact } from "./Contact";
import { FileMetadata } from "./FileMetadata";
import { User } from "./User";

export enum OwnerTypeMessage {
  CONTACT = "CONTACT",
  USER = "USER",
  ADMIN = "ADMIN",
  BOT = "BOT",
};

export enum MessageType {
  EMPTY = "EMPTY",
  TEXT = "TEXT",
  DOCUMENT = "DOCUMENT",
  IMAGE = "IMAGE",
  AUDIO = "AUDIO",
  VIDEO = "VIDEO",
  LOADING = "LOADING", // Usado somente em momentos de carregamento do arquivo anexado na mensagem...
  STICKER = "STICKER",
  LOCATION = "LOCATION",
  LIVE_LOCATION = "LIVE_LOCATION",
  CONTACT = "CONTACT",
  REACTION = "REACTION",
  POLL = "POLL",
  INTERNAL = "INTERNAL",
};

export enum MessageStatus {
  SENDING = "SENDING",
  SENT = "SENT",
  DELIVERED = "DELIVERED",
  READ = "READ",
  FAILED = "FAILED",
};

export interface Message {
  id: string;
  chat: Chat;
  chatId?: string;
  shipmentId?: string | null;
  replyToMessageId?: string | null;
  externalMessageId?: string | null;
  providerMessageId?: string | null;
  content: string;
  messageType: MessageType;
  ownerType: OwnerTypeMessage;
  user: User;
  contact: Contact;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
  channelDeletedAt?: Date | null;
  editedAt?: Date | null;
  status: MessageStatus;
  show?: boolean;
  fileMetadata: FileMetadata | null;
  reactions?: Array<MessageReaction>;
  replyToMessage?: Message | null;
  isForwarded?: boolean;
  localUpload?: LocalUploadFeedback;
};

export interface LocalUploadFeedback {
  status: "UPLOADING" | "FAILED";
  percentage: number;
  fileName?: string;
  error?: string | null;
  retryable?: boolean;
};

export interface MessageReaction {
  emoji: string;
  ownerType: OwnerTypeMessage;
  userId?: string;
  senderJid?: string;
  externalMessageId?: string;
  providerMessageId?: string;
  createdAt: Date;
};

export interface BotMessage {
  cardId: string;
};

// export enum MessageType {
//   TEXT = "TEXT",
//   // IMAGE = "IMAGE",
//   // VIDEO = "VIDEO",
//   // AUDIO = "AUDIO",
// };

// export type TextMessage = {
//   id: string;
//   type: MessageType.TEXT;
//   data: string | null;
// };

// export type ImageMessage = {
//   id: string;
//   type: MessageType.IMAGE;
//   data: File | null;
// };

// export type VideoMessage = {
//   id: string;
//   type: MessageType.VIDEO;
//   data: File | null;
// };

// export type AudioMessage = {
//   id: string;
//   type: MessageType.AUDIO;
//   data: File | null;
// };

// export type Message = TextMessage; // | ImageMessage | VideoMessage | AudioMessage;
